window.addEventListener('load', () => {
  // window fit image
  document.getElementsByClassName('mainslider-wrap')[0].style.height = Math.round(window.innerHeight/3) + 'px'
  // swiper

  // scroll controler
  let renderSyncGirls = false
  let scrollEvent = () => {
    if (!renderSyncGirls) {
        requestAnimationFrame(() => {
        // requestAnimationFrame(function (){
        renderSyncGirls = false


        //scroll parallax
        if (window.innerHeight >= window.pageYOffset) {
          // let calcPosition = window.pageYOffset / 25
          // [15 - 25] : ほぼphotoを固定したような感じ  [ 30 - 50]
          let calcPosition = window.pageYOffset / 32
          let calcPositionHeader = window.pageYOffset / 24
          document.getElementsByClassName('js_header')[0].style.transform = 'translateY(' + calcPositionHeader + '%)'

          if (document.getElementsByClassName('mainslider-wrap')[0].classList.contains('parallax-main-slider') == true){
            document.getElementsByClassName('js_parallax-main')[0].style.top = (-40 + calcPosition) + '%'
          } else {
            document.getElementsByClassName('js_parallax')[0].style.top = (50 + calcPosition) + '%'
          }
        }

        // ROOMS LIST PAGE.
        if (document.getElementsByClassName('content-wrap')[0].classList.contains('pickup-rooms') == true) {
          let Room601 = document.getElementsByClassName('slider-room601')[0].getBoundingClientRect().top + pageYOffset
          let Room601H = document.getElementsByClassName('slider-room601')[0].getBoundingClientRect().height
          let RoomLux = document.getElementsByClassName('slider-room-lux')[0].getBoundingClientRect().top + pageYOffset
          let RoomLuxH = document.getElementsByClassName('slider-room-lux')[0].getBoundingClientRect().height
          let RoomStdA = document.getElementsByClassName('js_parallax-std-type-a')[0].getBoundingClientRect().top + pageYOffset
          let RoomStdAH = document.getElementsByClassName('js_parallax-std-type-a')[0].getBoundingClientRect().height
          let RoomStdB = document.getElementsByClassName('js_parallax-std-type-b')[0].getBoundingClientRect().top + pageYOffset
          let RoomStdBH = document.getElementsByClassName('js_parallax-std-type-b')[0].getBoundingClientRect().height
          let RoomStdC = document.getElementsByClassName('js_parallax-std-type-c')[0].getBoundingClientRect().top + pageYOffset
          let RoomStdCH = document.getElementsByClassName('js_parallax-std-type-c')[0].getBoundingClientRect().height
          let RoomLuxD = document.getElementsByClassName('js_parallax-lux-type-d')[0].getBoundingClientRect().top + pageYOffset
          let RoomLuxDH = document.getElementsByClassName('js_parallax-lux-type-d')[0].getBoundingClientRect().height
          let RoomStdD = document.getElementsByClassName('js_parallax-std-type-d')[0].getBoundingClientRect().top + pageYOffset
          let RoomStdDH = document.getElementsByClassName('js_parallax-std-type-d')[0].getBoundingClientRect().height
          let RoomDesgE = document.getElementsByClassName('js_parallax-lux-type-e')[0].getBoundingClientRect().top + pageYOffset
          let RoomDesgEH = document.getElementsByClassName('js_parallax-lux-type-e')[0].getBoundingClientRect().height
          let RoomDesgF = document.getElementsByClassName('js_parallax-type-f')[0].getBoundingClientRect().top + pageYOffset
          let RoomDesgFH = document.getElementsByClassName('js_parallax-type-f')[0].getBoundingClientRect().height

          let currentScrl = window.pageYOffset + window.innerHeight

          if (Room601 <= currentScrl && Room601 + Room601H >= window.pageYOffset) {
            let calcPosition601 = (window.innerHeight - document.getElementsByClassName('slider-room601')[0].getBoundingClientRect().top) / 75 * 1
            document.getElementsByClassName('js_parallax-601')[0].style.top = (-20 + calcPosition601) + '%'
          }
          // Designers Type A
          if (RoomLux <= currentScrl && RoomLux + RoomLuxH >= window.pageYOffset) {
            let calcPosition601 = (window.innerHeight - document.getElementsByClassName('slider-room-lux')[0].getBoundingClientRect().top) / 75 * 1
            document.getElementsByClassName('js_parallax-lux')[0].style.top = (-20 + calcPosition601) + '%'
          }
          // Standard Type A
          if (RoomStdA <= currentScrl && RoomStdA + RoomStdAH >= window.pageYOffset) {
            let calcPosition601 = (window.innerHeight - document.getElementsByClassName('std-type-a')[0].getBoundingClientRect().top) / 75 * 1
            document.getElementsByClassName('js_parallax-std-type-a')[0].style.top = (-20 + calcPosition601) + '%'
          }
          // Standard Type B with SAUNA
          if (RoomStdB <= currentScrl && RoomStdB + RoomStdBH >= window.pageYOffset) {
            let calcPosition601 = (window.innerHeight - document.getElementsByClassName('std-type-b')[0].getBoundingClientRect().top) / 75 * 1
            document.getElementsByClassName('js_parallax-std-type-b')[0].style.top = (-20 + calcPosition601) + '%'
          }
          // Standard Type C
          if (RoomStdC <= currentScrl && RoomStdC + RoomStdCH >= window.pageYOffset) {
            let calcPosition601 = (window.innerHeight - document.getElementsByClassName('std-type-c')[0].getBoundingClientRect().top) / 75 * 1
            document.getElementsByClassName('js_parallax-std-type-c')[0].style.top = (-20 + calcPosition601) + '%'
          }
          // Designers Type D
          if (RoomLuxD <= currentScrl && RoomLuxD + RoomLuxDH >= window.pageYOffset) {
            let calcPosition601 = (window.innerHeight - document.getElementsByClassName('lux-type-d')[0].getBoundingClientRect().top) / 75 * 1
            document.getElementsByClassName('js_parallax-lux-type-d')[0].style.top = (-20 + calcPosition601) + '%'
          }
          // Standard Type D
          if (RoomStdD <= currentScrl && RoomStdD + RoomStdDH >= window.pageYOffset) {
            let calcPosition601 = (window.innerHeight - document.getElementsByClassName('std-type-d')[0].getBoundingClientRect().top) / 75 * 1
            document.getElementsByClassName('js_parallax-std-type-d')[0].style.top = (-20 + calcPosition601) + '%'
          }
          // Designers Type E
          if (RoomDesgE <= currentScrl && RoomDesgE + RoomDesgEH >= window.pageYOffset) {
            let calcPosition601 = (window.innerHeight - document.getElementsByClassName('lux-type-e')[0].getBoundingClientRect().top) / 75 * 1
            document.getElementsByClassName('js_parallax-lux-type-e')[0].style.top = (-20 + calcPosition601) + '%'
          }
          // Designers Type F
          if (RoomDesgF <= currentScrl && RoomDesgF + RoomDesgFH >= window.pageYOffset) {
            let calcPosition601 = (window.innerHeight - document.getElementsByClassName('type-f')[0].getBoundingClientRect().top) / 75 * 1
            document.getElementsByClassName('js_parallax-type-f')[0].style.top = (-20 + calcPosition601) + '%'
          }
        }
        // END ROOMS LIST PAGE.

        // STANDARD TYPE A
        if (document.getElementsByClassName('content-wrap')[0].classList.contains('parallax-2') == true) {
          let currentScrl = window.pageYOffset + window.innerHeight
          let Room01  = document.getElementsByClassName('prlx-01')[0].getBoundingClientRect().top + pageYOffset
          let Room01H  = document.getElementsByClassName('prlx-01')[0].getBoundingClientRect().height
          let Room02  = document.getElementsByClassName('prlx-02')[0].getBoundingClientRect().top + pageYOffset
          let Room02H  = document.getElementsByClassName('prlx-02')[0].getBoundingClientRect().height

          if (Room01 <= currentScrl && Room01 + Room01H >= window.pageYOffset) {
            let calcPosition01 = (window.innerHeight - document.getElementsByClassName('prlx-room01')[0].getBoundingClientRect().top) / 75 * 1
            document.getElementsByClassName('prlx-room01')[0].style.top = (-20 + calcPosition01) + '%'
          }
          if (Room02 <= currentScrl && Room02 + Room02H >= window.pageYOffset) {
            let calcPosition02 = (window.innerHeight - document.getElementsByClassName('prlx-room02')[0].getBoundingClientRect().top) / 75 * 1
            document.getElementsByClassName('prlx-room02')[0].style.top = (-20 + calcPosition02) + '%'
          }

        }
        // END STANDARD TYPE A


        // STANDARD TYPE A
        if (document.getElementsByClassName('content-wrap')[0].classList.contains('parallax-3') == true) {
          let currentScrl = window.pageYOffset + window.innerHeight
          let Room01  = document.getElementsByClassName('prlx-01')[0].getBoundingClientRect().top + pageYOffset
          let Room01H  = document.getElementsByClassName('prlx-01')[0].getBoundingClientRect().height
          let Room02  = document.getElementsByClassName('prlx-02')[0].getBoundingClientRect().top + pageYOffset
          let Room02H  = document.getElementsByClassName('prlx-02')[0].getBoundingClientRect().height
          let Room03  = document.getElementsByClassName('prlx-03')[0].getBoundingClientRect().top + pageYOffset
          let Room03H  = document.getElementsByClassName('prlx-03')[0].getBoundingClientRect().height

          if (Room01 <= currentScrl && Room01 + Room01H >= window.pageYOffset) {
            let calcPosition01 = (window.innerHeight - document.getElementsByClassName('prlx-room01')[0].getBoundingClientRect().top) / 75 * 1
            document.getElementsByClassName('prlx-room01')[0].style.top = (-20 + calcPosition01) + '%'
          }
          if (Room02 <= currentScrl && Room02 + Room02H >= window.pageYOffset) {
            let calcPosition02 = (window.innerHeight - document.getElementsByClassName('prlx-room02')[0].getBoundingClientRect().top) / 75 * 1
            document.getElementsByClassName('prlx-room02')[0].style.top = (-20 + calcPosition02) + '%'
          }
          if (Room03 <= currentScrl && Room03 + Room03H >= window.pageYOffset) {
            let calcPosition03 = (window.innerHeight - document.getElementsByClassName('prlx-room03')[0].getBoundingClientRect().top) / 75 * 1
            document.getElementsByClassName('prlx-room03')[0].style.top = (-20 + calcPosition03) + '%'
          }
        }


        // STANDARD TYPE A
        if (document.getElementsByClassName('content-wrap')[0].classList.contains('parallax-4') == true) {
          let currentScrl = window.pageYOffset + window.innerHeight
          let Room01  = document.getElementsByClassName('prlx-01')[0].getBoundingClientRect().top + pageYOffset
          let Room01H  = document.getElementsByClassName('prlx-01')[0].getBoundingClientRect().height
          let Room02  = document.getElementsByClassName('prlx-02')[0].getBoundingClientRect().top + pageYOffset
          let Room02H  = document.getElementsByClassName('prlx-02')[0].getBoundingClientRect().height
          let Room03  = document.getElementsByClassName('prlx-03')[0].getBoundingClientRect().top + pageYOffset
          let Room03H  = document.getElementsByClassName('prlx-03')[0].getBoundingClientRect().height
          let Room04  = document.getElementsByClassName('prlx-04')[0].getBoundingClientRect().top + pageYOffset
          let Room04H  = document.getElementsByClassName('prlx-04')[0].getBoundingClientRect().height

          if (Room01 <= currentScrl && Room01 + Room01H >= window.pageYOffset) {
            let calcPosition01 = (window.innerHeight - document.getElementsByClassName('prlx-room01')[0].getBoundingClientRect().top) / 75 * 1
            document.getElementsByClassName('prlx-room01')[0].style.top = (-20 + calcPosition01) + '%'
          }
          if (Room02 <= currentScrl && Room02 + Room02H >= window.pageYOffset) {
            let calcPosition02 = (window.innerHeight - document.getElementsByClassName('prlx-room02')[0].getBoundingClientRect().top) / 75 * 1
            document.getElementsByClassName('prlx-room02')[0].style.top = (-20 + calcPosition02) + '%'
          }
          if (Room03 <= currentScrl && Room03 + Room03H >= window.pageYOffset) {
            let calcPosition03 = (window.innerHeight - document.getElementsByClassName('prlx-room03')[0].getBoundingClientRect().top) / 75 * 1
            document.getElementsByClassName('prlx-room03')[0].style.top = (-20 + calcPosition03) + '%'
          }
          if (Room04 <= currentScrl && Room04 + Room04H >= window.pageYOffset) {
            let calcPosition04 = (window.innerHeight - document.getElementsByClassName('prlx-room04')[0].getBoundingClientRect().top) / 75 * 1
            document.getElementsByClassName('prlx-room04')[0].style.top = (-20 + calcPosition04) + '%'
          }
        }
        // END STANDARD TYPE A

        // TYPE B.C
        if (document.getElementsByClassName('content-wrap')[0].classList.contains('parallax-5') == true) {
          let currentScrl = window.pageYOffset + window.innerHeight
          let Room01  = document.getElementsByClassName('prlx-01')[0].getBoundingClientRect().top + pageYOffset
          let Room01H  = document.getElementsByClassName('prlx-01')[0].getBoundingClientRect().height
          let Room02  = document.getElementsByClassName('prlx-02')[0].getBoundingClientRect().top + pageYOffset
          let Room02H  = document.getElementsByClassName('prlx-02')[0].getBoundingClientRect().height
          let Room03  = document.getElementsByClassName('prlx-03')[0].getBoundingClientRect().top + pageYOffset
          let Room03H  = document.getElementsByClassName('prlx-03')[0].getBoundingClientRect().height
          let Room04  = document.getElementsByClassName('prlx-04')[0].getBoundingClientRect().top + pageYOffset
          let Room04H  = document.getElementsByClassName('prlx-04')[0].getBoundingClientRect().height
          let Room05  = document.getElementsByClassName('prlx-05')[0].getBoundingClientRect().top + pageYOffset
          let Room05H  = document.getElementsByClassName('prlx-05')[0].getBoundingClientRect().height

          if (Room01 <= currentScrl && Room01 + Room01H >= window.pageYOffset) {
            let calcPosition01 = (window.innerHeight - document.getElementsByClassName('prlx-room01')[0].getBoundingClientRect().top) / 75 * 1
            document.getElementsByClassName('prlx-room01')[0].style.top = (-20 + calcPosition01) + '%'
          }
          if (Room02 <= currentScrl && Room02 + Room02H >= window.pageYOffset) {
            let calcPosition02 = (window.innerHeight - document.getElementsByClassName('prlx-room02')[0].getBoundingClientRect().top) / 75 * 1
            document.getElementsByClassName('prlx-room02')[0].style.top = (-20 + calcPosition02) + '%'
          }
          if (Room03 <= currentScrl && Room03 + Room03H >= window.pageYOffset) {
            let calcPosition03 = (window.innerHeight - document.getElementsByClassName('prlx-room03')[0].getBoundingClientRect().top) / 75 * 1
            document.getElementsByClassName('prlx-room03')[0].style.top = (-20 + calcPosition03) + '%'
          }
          if (Room04 <= currentScrl && Room04 + Room04H >= window.pageYOffset) {
            let calcPosition04 = (window.innerHeight - document.getElementsByClassName('prlx-room04')[0].getBoundingClientRect().top) / 75 * 1
            document.getElementsByClassName('prlx-room04')[0].style.top = (-20 + calcPosition04) + '%'
          }
          if (Room05 <= currentScrl && Room05 + Room05H >= window.pageYOffset) {
            let calcPosition05 = (window.innerHeight - document.getElementsByClassName('prlx-room05')[0].getBoundingClientRect().top) / 75 * 1
            document.getElementsByClassName('prlx-room05')[0].style.top = (-20 + calcPosition05) + '%'
          }
        }
        // END TYPE B.C

        // TYPE D DESIGNERS STANDARD
        if (document.getElementsByClassName('content-wrap')[0].classList.contains('parallax-6') == true) {
          let currentScrl = window.pageYOffset + window.innerHeight
          let Room01  = document.getElementsByClassName('prlx-01')[0].getBoundingClientRect().top + pageYOffset
          let Room01H  = document.getElementsByClassName('prlx-01')[0].getBoundingClientRect().height
          let Room02  = document.getElementsByClassName('prlx-02')[0].getBoundingClientRect().top + pageYOffset
          let Room02H  = document.getElementsByClassName('prlx-02')[0].getBoundingClientRect().height
          let Room03  = document.getElementsByClassName('prlx-03')[0].getBoundingClientRect().top + pageYOffset
          let Room03H  = document.getElementsByClassName('prlx-03')[0].getBoundingClientRect().height
          let Room04  = document.getElementsByClassName('prlx-04')[0].getBoundingClientRect().top + pageYOffset
          let Room04H  = document.getElementsByClassName('prlx-04')[0].getBoundingClientRect().height
          let Room05  = document.getElementsByClassName('prlx-05')[0].getBoundingClientRect().top + pageYOffset
          let Room05H  = document.getElementsByClassName('prlx-05')[0].getBoundingClientRect().height
          let Room06  = document.getElementsByClassName('prlx-06')[0].getBoundingClientRect().top + pageYOffset
          let Room06H  = document.getElementsByClassName('prlx-06')[0].getBoundingClientRect().height

          if (Room01 <= currentScrl && Room01 + Room01H >= window.pageYOffset) {
            let calcPosition01 = (window.innerHeight - document.getElementsByClassName('prlx-room01')[0].getBoundingClientRect().top) / 75 * 1
            document.getElementsByClassName('prlx-room01')[0].style.top = (-20 + calcPosition01) + '%'
          }
          if (Room02 <= currentScrl && Room02 + Room02H >= window.pageYOffset) {
            let calcPosition02 = (window.innerHeight - document.getElementsByClassName('prlx-room02')[0].getBoundingClientRect().top) / 75 * 1
            document.getElementsByClassName('prlx-room02')[0].style.top = (-20 + calcPosition02) + '%'
          }
          if (Room03 <= currentScrl && Room03 + Room03H >= window.pageYOffset) {
            let calcPosition03 = (window.innerHeight - document.getElementsByClassName('prlx-room03')[0].getBoundingClientRect().top) / 75 * 1
            document.getElementsByClassName('prlx-room03')[0].style.top = (-20 + calcPosition03) + '%'
          }
          if (Room04 <= currentScrl && Room04 + Room04H >= window.pageYOffset) {
            let calcPosition04 = (window.innerHeight - document.getElementsByClassName('prlx-room04')[0].getBoundingClientRect().top) / 75 * 1
            document.getElementsByClassName('prlx-room04')[0].style.top = (-20 + calcPosition04) + '%'
          }
          if (Room05 <= currentScrl && Room05 + Room05H >= window.pageYOffset) {
            let calcPosition05 = (window.innerHeight - document.getElementsByClassName('prlx-room05')[0].getBoundingClientRect().top) / 75 * 1
            document.getElementsByClassName('prlx-room05')[0].style.top = (-20 + calcPosition05) + '%'
          }
          if (Room06 <= currentScrl && Room06 + Room06H >= window.pageYOffset) {
            let calcPosition06 = (window.innerHeight - document.getElementsByClassName('prlx-room06')[0].getBoundingClientRect().top) / 75 * 1
            document.getElementsByClassName('prlx-room06')[0].style.top = (-20 + calcPosition06) + '%'
          }
        }
        // END TYPE D DESIGNERS STANDARD


        // TYPE D
        if (document.getElementsByClassName('content-wrap')[0].classList.contains('parallax-7') == true) {
          let currentScrl = window.pageYOffset + window.innerHeight
          let Room01  = document.getElementsByClassName('prlx-01')[0].getBoundingClientRect().top + pageYOffset
          let Room01H  = document.getElementsByClassName('prlx-01')[0].getBoundingClientRect().height
          let Room02  = document.getElementsByClassName('prlx-02')[0].getBoundingClientRect().top + pageYOffset
          let Room02H  = document.getElementsByClassName('prlx-02')[0].getBoundingClientRect().height
          let Room03  = document.getElementsByClassName('prlx-03')[0].getBoundingClientRect().top + pageYOffset
          let Room03H  = document.getElementsByClassName('prlx-03')[0].getBoundingClientRect().height
          let Room04  = document.getElementsByClassName('prlx-04')[0].getBoundingClientRect().top + pageYOffset
          let Room04H  = document.getElementsByClassName('prlx-04')[0].getBoundingClientRect().height
          let Room05  = document.getElementsByClassName('prlx-05')[0].getBoundingClientRect().top + pageYOffset
          let Room05H  = document.getElementsByClassName('prlx-05')[0].getBoundingClientRect().height
          let Room06  = document.getElementsByClassName('prlx-06')[0].getBoundingClientRect().top + pageYOffset
          let Room06H  = document.getElementsByClassName('prlx-06')[0].getBoundingClientRect().height
          let Room07  = document.getElementsByClassName('prlx-07')[0].getBoundingClientRect().top + pageYOffset
          let Room07H  = document.getElementsByClassName('prlx-07')[0].getBoundingClientRect().height

          if (Room01 <= currentScrl && Room01 + Room01H >= window.pageYOffset) {
            let calcPosition01 = (window.innerHeight - document.getElementsByClassName('prlx-room01')[0].getBoundingClientRect().top) / 75 * 1
            document.getElementsByClassName('prlx-room01')[0].style.top = (-20 + calcPosition01) + '%'
          }
          if (Room02 <= currentScrl && Room02 + Room02H >= window.pageYOffset) {
            let calcPosition02 = (window.innerHeight - document.getElementsByClassName('prlx-room02')[0].getBoundingClientRect().top) / 75 * 1
            document.getElementsByClassName('prlx-room02')[0].style.top = (-20 + calcPosition02) + '%'
          }
          if (Room03 <= currentScrl && Room03 + Room03H >= window.pageYOffset) {
            let calcPosition03 = (window.innerHeight - document.getElementsByClassName('prlx-room03')[0].getBoundingClientRect().top) / 75 * 1
            document.getElementsByClassName('prlx-room03')[0].style.top = (-20 + calcPosition03) + '%'
          }
          if (Room04 <= currentScrl && Room04 + Room04H >= window.pageYOffset) {
            let calcPosition04 = (window.innerHeight - document.getElementsByClassName('prlx-room04')[0].getBoundingClientRect().top) / 75 * 1
            document.getElementsByClassName('prlx-room04')[0].style.top = (-20 + calcPosition04) + '%'
          }
          if (Room05 <= currentScrl && Room05 + Room05H >= window.pageYOffset) {
            let calcPosition05 = (window.innerHeight - document.getElementsByClassName('prlx-room05')[0].getBoundingClientRect().top) / 75 * 1
            document.getElementsByClassName('prlx-room05')[0].style.top = (-20 + calcPosition05) + '%'
          }
          if (Room06 <= currentScrl && Room06 + Room06H >= window.pageYOffset) {
            let calcPosition06 = (window.innerHeight - document.getElementsByClassName('prlx-room06')[0].getBoundingClientRect().top) / 75 * 1
            document.getElementsByClassName('prlx-room06')[0].style.top = (-20 + calcPosition06) + '%'
          }
          if (Room07 <= currentScrl && Room07 + Room07H >= window.pageYOffset) {
            let calcPosition07 = (window.innerHeight - document.getElementsByClassName('prlx-room07')[0].getBoundingClientRect().top) / 75 * 1
            document.getElementsByClassName('prlx-room07')[0].style.top = (-20 + calcPosition07) + '%'
          }
        }
        // END TYPE D

        // SLIDE 10
        if (document.getElementsByClassName('content-wrap')[0].classList.contains('parallax-10') == true) {
          let currentScrl = window.pageYOffset + window.innerHeight
          let Room01  = document.getElementsByClassName('prlx-01')[0].getBoundingClientRect().top + pageYOffset
          let Room01H  = document.getElementsByClassName('prlx-01')[0].getBoundingClientRect().height
          let Room02  = document.getElementsByClassName('prlx-02')[0].getBoundingClientRect().top + pageYOffset
          let Room02H  = document.getElementsByClassName('prlx-02')[0].getBoundingClientRect().height
          let Room03  = document.getElementsByClassName('prlx-03')[0].getBoundingClientRect().top + pageYOffset
          let Room03H  = document.getElementsByClassName('prlx-03')[0].getBoundingClientRect().height
          let Room04  = document.getElementsByClassName('prlx-04')[0].getBoundingClientRect().top + pageYOffset
          let Room04H  = document.getElementsByClassName('prlx-04')[0].getBoundingClientRect().height
          let Room05  = document.getElementsByClassName('prlx-05')[0].getBoundingClientRect().top + pageYOffset
          let Room05H  = document.getElementsByClassName('prlx-05')[0].getBoundingClientRect().height
          let Room06  = document.getElementsByClassName('prlx-06')[0].getBoundingClientRect().top + pageYOffset
          let Room06H  = document.getElementsByClassName('prlx-06')[0].getBoundingClientRect().height
          let Room07  = document.getElementsByClassName('prlx-07')[0].getBoundingClientRect().top + pageYOffset
          let Room07H  = document.getElementsByClassName('prlx-07')[0].getBoundingClientRect().height
          let Room08  = document.getElementsByClassName('prlx-08')[0].getBoundingClientRect().top + pageYOffset
          let Room08H  = document.getElementsByClassName('prlx-08')[0].getBoundingClientRect().height
          let Room09  = document.getElementsByClassName('prlx-09')[0].getBoundingClientRect().top + pageYOffset
          let Room09H  = document.getElementsByClassName('prlx-09')[0].getBoundingClientRect().height
          let Room10  = document.getElementsByClassName('prlx-10')[0].getBoundingClientRect().top + pageYOffset
          let Room10H  = document.getElementsByClassName('prlx-10')[0].getBoundingClientRect().height

          if (Room01 <= currentScrl && Room01 + Room01H >= window.pageYOffset) {
            let calcPosition01 = (window.innerHeight - document.getElementsByClassName('prlx-room01')[0].getBoundingClientRect().top) / 75 * 1
            document.getElementsByClassName('prlx-room01')[0].style.top = (-20 + calcPosition01) + '%'
          }
          if (Room02 <= currentScrl && Room02 + Room02H >= window.pageYOffset) {
            let calcPosition02 = (window.innerHeight - document.getElementsByClassName('prlx-room02')[0].getBoundingClientRect().top) / 75 * 1
            document.getElementsByClassName('prlx-room02')[0].style.top = (-20 + calcPosition02) + '%'
          }
          if (Room03 <= currentScrl && Room03 + Room03H >= window.pageYOffset) {
            let calcPosition03 = (window.innerHeight - document.getElementsByClassName('prlx-room03')[0].getBoundingClientRect().top) / 75 * 1
            document.getElementsByClassName('prlx-room03')[0].style.top = (-20 + calcPosition03) + '%'
          }
          if (Room04 <= currentScrl && Room04 + Room04H >= window.pageYOffset) {
            let calcPosition04 = (window.innerHeight - document.getElementsByClassName('prlx-room04')[0].getBoundingClientRect().top) / 75 * 1
            document.getElementsByClassName('prlx-room04')[0].style.top = (-20 + calcPosition04) + '%'
          }
          if (Room05 <= currentScrl && Room05 + Room05H >= window.pageYOffset) {
            let calcPosition05 = (window.innerHeight - document.getElementsByClassName('prlx-room05')[0].getBoundingClientRect().top) / 75 * 1
            document.getElementsByClassName('prlx-room05')[0].style.top = (-20 + calcPosition05) + '%'
          }
          if (Room06 <= currentScrl && Room06 + Room06H >= window.pageYOffset) {
            let calcPosition06 = (window.innerHeight - document.getElementsByClassName('prlx-room06')[0].getBoundingClientRect().top) / 75 * 1
            document.getElementsByClassName('prlx-room06')[0].style.top = (-20 + calcPosition06) + '%'
          }
          if (Room07 <= currentScrl && Room07 + Room07H >= window.pageYOffset) {
            let calcPosition07 = (window.innerHeight - document.getElementsByClassName('prlx-room07')[0].getBoundingClientRect().top) / 75 * 1
            document.getElementsByClassName('prlx-room07')[0].style.top = (-20 + calcPosition07) + '%'
          }
          if (Room08 <= currentScrl && Room08 + Room08H >= window.pageYOffset) {
            let calcPosition08 = (window.innerHeight - document.getElementsByClassName('prlx-room08')[0].getBoundingClientRect().top) / 75 * 1
            document.getElementsByClassName('prlx-room08')[0].style.top = (-20 + calcPosition08) + '%'
          }
          if (Room09 <= currentScrl && Room09 + Room09H >= window.pageYOffset) {
            let calcPosition09 = (window.innerHeight - document.getElementsByClassName('prlx-room09')[0].getBoundingClientRect().top) / 75 * 1
            document.getElementsByClassName('prlx-room09')[0].style.top = (-20 + calcPosition09) + '%'
          }
          if (Room10 <= currentScrl && Room10 + Room10H >= window.pageYOffset) {
            let calcPosition10 = (window.innerHeight - document.getElementsByClassName('prlx-room10')[0].getBoundingClientRect().top) / 75 * 1
            document.getElementsByClassName('prlx-room10')[0].style.top = (-20 + calcPosition10) + '%'
          }
        }
        // END SLIDE 10


      }) //requestAnimationFrame
    } //if rendersyncgirls
  } //scrollEvent
  document.addEventListener('scroll', scrollEvent, {passive: true})


  // ONLY ROOMDE LIST
  // if (document.getElementsByClassName('room-list')[0] != null) {
  //   let hideInfoObj = document.getElementsByClassName('swiper-wrapper')
  //   for (let index = 0; index < hideInfoObj.length; index++) {
  //     // const element = array[index];
  //     hideInfoObj[index].addEventListener('mouseover', function(event){
  //       document.getElementsByClassName('room-info')[index].classList.add('active')
  //     })
  //     hideInfoObj[index].addEventListener('mouseleave', function(event){
  //       document.getElementsByClassName('room-info')[index].classList.remove('active')
  //     })
  //   } // end for
  // } // ONLY ROOMDE LIST

  if (document.getElementsByClassName('room-list')[0] != null) {
    let hideInfoObj = document.getElementsByClassName('hide-info')
    for (let index = 0; index < hideInfoObj.length; index++) {
      // const element = array[index];
      hideInfoObj[index].addEventListener('mouseover', function(event){
        document.getElementsByClassName('room-info')[index].classList.add('active')
      })
      hideInfoObj[index].addEventListener('mouseleave', function(event){
        document.getElementsByClassName('room-info')[index].classList.remove('active')
      })
    } // end for

    let MarineObj = document.getElementsByClassName('room-description')
    for (let objects = 0; objects < MarineObj.length; objects++) {
      MarineObj[objects].style.height = MarineObj[objects].getElementsByClassName('marine-box')[0].offsetHeight + 'px'

    }


  } // ONLY ROOMDE LIST

  // ONLY ROOMDETAIL
  if (document.getElementsByClassName('room-detail')[0] != null) {
    let hideInfoObj = document.getElementsByClassName('swiper-wrapper')
    for (let index = 0; index < hideInfoObj.length; index++) {
      // const element = array[index];
      hideInfoObj[index].addEventListener('mouseover', function(event){
        document.getElementsByClassName('room-info')[index].classList.add('active')
      })
      hideInfoObj[index].addEventListener('mouseleave', function(event){
        document.getElementsByClassName('room-info')[index].classList.remove('active')
      })
    } // end for
  } // ONLY ROOMDETAIL


}) // onload
